import { Code } from 'lucide-react'
import { AuthoredIcon } from '@/components/admin/shared/authored-icon'

export interface SourceIconProps {
  sourceIcon?: string | null
  source?: string
}

/**
 * A problem's source mark in the command palette.
 *
 * Rows with no icon at all render nothing — palette rows are dense, and a
 * generic mark on every source-less row would be noise rather than
 * information. An icon that is authored but fails to load is a different
 * case, and gets the generic mark so the row doesn't silently lose a column.
 *
 * `AuthoredIcon` owns the emoji-vs-image decision and the sizing, so there is
 * no longer a pixel `size` prop: palette rows are all one type scale, and
 * `sm` matches it.
 */
export function SourceIcon({ sourceIcon, source }: SourceIconProps) {
  if (!sourceIcon?.trim()) return null

  // These rows name their source nowhere else, so `label` carries the name —
  // AuthoredIcon emits both the title and the screen-reader text, since it is
  // the module that made the mark decorative in the first place.
  return (
    <span className="inline-flex shrink-0 items-center">
      <AuthoredIcon
        icon={sourceIcon}
        size="sm"
        label={source || 'Source'}
        className="text-muted-foreground rounded"
        fallback={Code}
      />
    </span>
  )
}
